/* NFS Packtisch EU labels. No analytics, cookies, or customer data sent to NFS. */
(() => {
  'use strict';
  const source = document.getElementById('nfs-eu-warranty-context');
  if (!source || window.nfsEuWarrantyStarted) return;
  window.nfsEuWarrantyStarted = true;
  let context; try { context = JSON.parse(source.textContent); } catch { return; }
  let config = {enabled:false}, cart = context.cart || [], refreshTimer, cartTimer, running = false;
  const labels = {bg:'Вашите законови гаранционни права',cs:'Vaše zákonná práva ze záruky',da:'Dine lovbestemte garantirettigheder',de:'Deine gesetzlichen Gewährleistungsrechte',el:'Τα νόμιμα δικαιώματα εγγύησής σας',en:'Your legal guarantee rights',es:'Tus derechos de garantía legal',et:'Teie seaduslikud garantiiõigused',fi:'Lakisääteiset takuuoikeutesi',fr:'Vos droits à la garantie légale',ga:'Do chearta ráthaíochta dlíthiúla',hr:'Vaša zakonska jamstvena prava',hu:'Az Ön törvényes jótállási jogai',it:'I tuoi diritti di garanzia legale',lt:'Jūsų teisės pagal teisinę garantiją',lv:'Jūsu likumīgās garantijas tiesības',mt:'Id-drittijiet tiegħek tal-garanzija legali',nl:'Je wettelijke garantierechten',pl:'Twoje prawa z gwarancji prawnej',pt:'Os seus direitos de garantia legal',ro:'Drepturile tale de garanție legală',sk:'Vaše zákonné práva zo záruky',sl:'Vaše zakonske garancijske pravice',sv:'Dina lagstadgade garantirättigheter'};
  const lang = () => {const l = (context.locale || '').toLowerCase().split(/[-_]/)[0];return config.languages?.includes(l) ? l : config.fallback_locale || 'de';};
  const text = () => labels[lang()] || labels.en;
  const make = (tag, value, cls) => {const n=document.createElement(tag);if(value)n.textContent=value;if(cls)n.className=cls;return n;};
  const image = (url, title) => {const i=make('img');i.src=url;i.alt=title;i.loading='lazy';return i;};
  const link = (url, label) => {const a=make('a',label);a.href=url;a.target='_blank';a.rel='noopener';return a;};
  const observedRoots=new WeakSet();
  function roots() {
    const result=[document],shadow=document.getElementById('opus-shadow-container')?.shadowRoot;
    if(shadow) {
      result.push(shadow);
      if(!observedRoots.has(shadow)){observer.observe(shadow,{childList:true,subtree:true});observedRoots.add(shadow);}
      if(!shadow.querySelector('#nfs-eu-warranty-css')) {
        const original=document.querySelector('link[href*="nfs-eu-warranty.css"]');
        if(original){const css=make('link');css.id='nfs-eu-warranty-css';css.rel='stylesheet';css.href=original.href;shadow.prepend(css);}
      }
    }
    return result;
  }
  const queryAll=selector=>roots().flatMap(root=>[...root.querySelectorAll(selector)]);
  function visible(placement) {
    if (!config.enabled || config.provider !== 'internal' || !config.placements?.[placement]) return false;
    if (config.hide_b2b && context.b2b) return false;
    if (config.only_eu && context.country && !config.eu_countries.includes(context.country)) return false;
    return true;
  }
  function eligible(p, placement) {
    if (!visible(placement)) return false;
    if (p.gift_card || p.physical === false) return false;
    const value=config.products?.[String(p.id)] || {};
    if (value.excluded) return false;
    return !(config.rules || []).some(r => {
      const actual=r.field==='tag'?p.tags||[]:p[r.field]||'';
      return (Array.isArray(actual)?actual:[actual]).some(v=>String(v).toLowerCase()===r.value.toLowerCase());
    });
  }
  function dialog(url, title, destination) {
    const d=make('dialog',null,'nfs-eu-warranty-dialog'), close=make('button',lang()==='de'?'Schließen':'Close');
    d.setAttribute('aria-label',title);close.type='button';close.onclick=()=>{d.close();d.remove();};
    d.addEventListener('close',()=>d.remove());d.append(close,image(url,title),link(destination,title));document.body.append(d);
    if (d.showModal) d.showModal(); else {d.setAttribute('open','');d.scrollIntoView();}
  }
  function build(products) {
    const box=make('aside',null,'nfs-eu-warranty');box.setAttribute('aria-label',text());
    const url=config.base_url+'/notice/'+lang()+'.svg';
    if (config.display==='inline') {
      box.classList.add('nfs-eu-warranty--inline');
      const style=config.style||{};
      for(const k of ['background','text','accent','border'])if(/^#[0-9a-f]{6}$/i.test(style[k]||''))box.style.setProperty('--nfs-'+k,style[k]);
      if(style.font_size>=12&&style.font_size<=24)box.style.fontSize=style.font_size+'px';
      if(style.max_width>=300&&style.max_width<=900)box.style.setProperty('--nfs-width',style.max_width+'px');
      box.append(image(url,text()),link(config.legal_link,text()));
    }
    else {
      const b=document.getElementById('nfs-eu-warranty-button')?.content?.querySelector('button')?.cloneNode(true) || make('button',text());
      const label=b.querySelector('[data-nfs-warranty-label]');if(label)label.textContent=text();else b.textContent=text();
      b.type='button';b.onclick=()=>dialog(url,text(),config.legal_link);box.append(b);
    }
    if (products.some(p=>config.products?.[String(p.id)]?.used)) box.append(make('p',lang()==='de'?'Hinweis: Dieser Kauf enthält gebrauchte Ware.':'Notice: This purchase includes used goods.'));
    for (const p of products) {
      const g=config.garan_enabled && config.products?.[String(p.id)]?.garan;
      if (!g) continue;
      const line=make('div',null,'nfs-eu-warranty-garan'), button=make('button');
      button.append(image(config.base_url+'/garan/'+p.id+'.svg?nested=true','GARAN · '+g.years+' · '+(p.title || g.model)));
      button.type='button';button.onclick=()=>dialog(config.base_url+'/garan/'+p.id+'.svg','GARAN · '+g.brand+' · '+g.model,config.garan_link);
      line.append(button,link(g.terms_url,lang()==='de'?'Garantiebedingungen':'Guarantee terms'));box.append(line);
    }
    return box;
  }
  function mountFooter() {
    const host=document.querySelector('[data-nfs-warranty-footer]') ||
      document.querySelector('#footer .ftr__cols a[href="/pages/agb"]')?.parentElement ||
      document.querySelector('footer .footer-block__details-content a[href="/pages/agb"]')?.closest('ul');
    const existing=[...document.querySelectorAll('[data-nfs-warranty-footer-link]')];
    let trigger=existing.find(n=>host?.contains(n));
    for(const node of existing)if(node!==trigger){node.closest('[data-nfs-warranty-footer-item]')?.remove();node.remove();}
    if(!host || !visible('footer')) {
      trigger?.closest('[data-nfs-warranty-footer-item]')?.remove();trigger?.remove();return;
    }
    const signature=JSON.stringify([config.revision,lang()]);
    if(trigger?.dataset.signature===signature)return;
    trigger?.closest('[data-nfs-warranty-footer-item]')?.remove();trigger?.remove();
    trigger=document.getElementById('nfs-eu-warranty-footer')?.content?.querySelector('a')?.cloneNode(true);
    if(!trigger)return;
    trigger.dataset.signature=signature;
    const label=trigger.querySelector('[data-nfs-warranty-label]');if(label)label.textContent=text();else trigger.textContent=text();
    trigger.href=config.legal_link;trigger.onclick=event=>{event.preventDefault();dialog(config.base_url+'/notice/'+lang()+'.svg',text(),config.legal_link);};
    if(host.tagName==='UL' || host.tagName==='OL') {
      const item=make('li');item.dataset.nfsWarrantyFooterItem='';item.append(trigger);host.append(item);
    } else host.append(trigger);
  }
  function mount(host, products, placement, after = null) {
    if(!host) return;
    const included=[...new Map(products.filter(p=>eligible(p,placement)).map(p=>[String(p.id),p])).values()];
    const signature=JSON.stringify([config.revision,context.country,context.b2b,lang(),included]);
    let box=[...host.children].find(n=>n.classList.contains('nfs-eu-warranty'));
    if (!included.length) {box?.remove();return;}
    if(box?.dataset.signature===signature) {
      if(after?.parentNode===host && after.nextElementSibling!==box) after.after(box);
      return;
    }
    box?.remove();box=build(included);box.dataset.signature=signature;box.dataset.placement=placement;
    const trigger=box.querySelector('[data-nfs-warranty-trigger]');
    if(trigger && host.getRootNode() instanceof ShadowRoot) {
      // Reuse the theme's real stylesheet inside an isolated root, without changing Opus controls.
      const container=make('div'),root=container.attachShadow({mode:'open'});
      for(const original of document.querySelectorAll('link[rel="stylesheet"][href*="/assets/theme.css"],link[rel="stylesheet"][href*="/assets/vendor.css"]')) {
        const css=make('link');css.rel='stylesheet';css.href=original.href;root.append(css);
      }
      root.append(trigger);box.prepend(container);
    }
    if(after?.parentNode===host) after.after(box);
    else {
      // In cart forms, precede checkout/payment buttons so the notice is encountered first.
      const action=host.querySelector('[name="checkout"],.shopify-payment-button,.cart__checkout-button');
      if(action?.parentNode===host) host.insertBefore(box,action); else host.prepend(box);
    }
  }
  function render() {
    if(running) return;running=true;
    try {
      mountFooter();
      if(!config.enabled || config.provider!=='internal') {queryAll('.nfs-eu-warranty,.nfs-eu-warranty-dialog').forEach(n=>{if(n.open)n.close();n.remove();});return;}
      if(context.product) {
        const select=document.querySelector('form[action*="/cart/add"] input[name="id"],form[action*="/cart/add"] select[name="id"]');
        const variant=context.product.variants?.find(v=>v.id===select?.value), p={...context.product,...variant};
        p.id=context.product.id;delete p.variants;
        // Product metadata is inherited for every newly created product; no catalog sync needed.
        const form=document.querySelector('form[action*="/cart/add"]'), blocks=form?.closest('.product__blocks');
        // Use the theme's delivery block; fall back to the purchase block if delivery is absent.
        const after=blocks?.querySelector('.product__block--shipping') || blocks?.querySelector('.product__block--buy_buttons');
        const host=after?.parentElement || form;
        queryAll('.nfs-eu-warranty[data-placement="product"]').forEach(box=>{if(box.parentElement!==host)box.remove();});
        mount(host,[p],'product',after);
      }
      const hosts=new Set(queryAll('form[action$="/cart"],form[action$="/cart/"],.cart-drawer__footer,.cart__footer,#CartDrawer .drawer__footer,.opus-drawer-container .cd-checkout-section-container,[data-nfs-warranty-cart]'));
      const leaves=[...hosts].filter(host=>![...hosts].some(other=>other!==host && host.contains(other)));
      // Some themes keep quantity controls in a form and checkout in a sibling footer.
      const selected=leaves.filter(host=>host.tagName!=='FORM' || host.querySelector('[name="checkout"],.shopify-payment-button,.cart__checkout-button') ||
        !leaves.some(other=>other!==host && host.parentElement?.contains(other)));
      queryAll('.nfs-eu-warranty[data-placement="cart"]').forEach(box=>{if(!selected.includes(box.parentElement))box.remove();});
      for(const host of selected) mount(host,cart,'cart');
    } finally {running=false;}
  }
  async function refreshConfig() {
    try {const r=await fetch(context.base_url+'/config.json',{cache:'no-store',credentials:'omit'});if(!r.ok)throw Error();config=await r.json();}
    catch {config={enabled:false};}
    render();
  }
  async function refreshCart() {
    try {
      const root=window.Shopify?.routes?.root || '/',r=await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store'});
      if(!r.ok)throw Error();const data=await r.json();
      const metadata=new Map(cart.map(p=>[String(p.id),p]));
      cart=await Promise.all(data.items.map(async item=>{
        let p=metadata.get(String(item.product_id));
        if(!p){const pr=await fetch(root+'products/'+encodeURIComponent(item.handle)+'.js',{credentials:'same-origin'});if(!pr.ok)throw Error();const pd=await pr.json();p={tags:pd.tags,vendor:pd.vendor,product_type:pd.type};}
        return {...p,id:String(item.product_id),handle:item.handle,sku:item.sku,title:item.product_title,physical:item.requires_shipping,gift_card:item.gift_card};
      }));render();
    } catch { /* Preserve the last confirmed cart; do not create invented product metadata. */ }
  }
  const observer=new MutationObserver(records=>{
    if(records.every(r=>r.target.closest?.('.nfs-eu-warranty,.nfs-eu-warranty-dialog')))return;
    clearTimeout(cartTimer);cartTimer=setTimeout(()=>{render();refreshCart();},350);
  });observer.observe(document.body,{childList:true,subtree:true});
  document.addEventListener('change',()=>{render();clearTimeout(cartTimer);cartTimer=setTimeout(refreshCart,200);});
  for(const event of ['cart:updated','cart:refresh','shopify:section:load'])document.addEventListener(event,()=>{render();refreshCart();});
  document.addEventListener('visibilitychange',()=>{if(!document.hidden){refreshConfig();refreshCart();}});
  refreshConfig();refreshCart();refreshTimer=setInterval(refreshConfig,15000);
})();
